// extracted by mini-css-extract-plugin
module.exports = {"icon":"multiple-select_icon__3t92Z","error":"multiple-select_error__2YM6S","required":"multiple-select_required__3ECsh"};